import qrcode from 'qrcode-generator'
class BaseAuth {
    constructor(root, settings) {
        this.root = root;
        this.settings = settings;
        this.translatableStrings = {
            keyCopied: this.settings.translatables.keyCopied,
            webauthn_not_available: this.settings.translatables.webauthn_not_available,
            unknown_error: this.settings.translatables.unknown_error,
            response_error: this.settings.translatables.response_error,
            passkey_not_found: this.settings.translatables.passkey_not_found,
            passkey_login_error: this.settings.translatables.passkey_login_error,
            passkey_registration_error: this.settings.translatables.passkey_registration_error,
            passkey_login_success: this.settings.translatables.passkey_login_success,
            passkey_configuration: this.settings.translatables.passkey_configuration,
            error_assertion: this.settings.translatables.error_assertion,
            notice_inform: this.settings.translatables.notice_inform,
            register_passkey: this.settings.translatables.register_passkey,
            network_not_ok: this.settings.translatables.network_not_ok,
            error_complete_registration: this.settings.translatables.error_complete_registration,
            usb: this.settings.translatables.usb,
            nfc: this.settings.translatables.nfc,
            ble: this.settings.translatables.ble,
            internal: this.settings.translatables.internal,
            cross_platform: this.settings.translatables.cross_platform,
            unknown: this.settings.translatables.unknown,
            pending: this.settings.translatables.pending,
            success: this.settings.translatables.success,
            login: this.settings.translatables.login,
            login_failed: this.settings.translatables.login_failed,
            log_in_with_passkey: this.settings.translatables.log_in_with_passkey,
            or: this.settings.translatables.or,
        };
    }
    getElement = (id) => document.getElementById(id);

    getCheckedInputValue = (name) => document.querySelector(`input[name="${name}"]:checked`).value;

    /**
     * Performs a fetch operation.
     *
     * @param {string} urlExtension - The URL extension to perform the fetch operation on.
     * @param {Object} data - The data to be sent in the fetch operation.
     * @param {string} [method='POST'] - The HTTP method to be used in the fetch operation. Defaults to 'POST'.
     * @returns {Promise} - A Promise that resolves with the response of the fetch operation.
     */
    performFetchOp = (urlExtension, data, method = 'POST') => {
        let url = this.root + urlExtension;
        let fetchParams = {
            method: method,
            headers: {'Content-Type': 'application/json',},
        };
        if (method === 'POST') {
            fetchParams.body = JSON.stringify(data);
        }
        return fetch(url, fetchParams);
    };

    assignClickListener = (id, callback) => {
        const element = this.getElement(id);
        if (element) {
            element.addEventListener('click', function (e) {
                e.preventDefault();
                callback();
            });
        }
    }



    logFetchError = (error) => console.error('There has been a problem with your fetch operation:', error);

    /**
     * Generates a QR code for Two-Factor Authentication using the TOTP URL.
     * If the TOTP URL is not available, nothing will be generated.
     *
     * @function qr_generator
     * @returns {void} Nothing is returned.
     */
    qr_generator = () => {
        const totp_url = this.settings.totp_data.totp_url;
        if (!totp_url) {
            return;
        }

        let qr = qrcode(0, 'L');
        qr.addData(totp_url);
        qr.make();
        let qrElem = document.querySelector('#two-factor-qr-code a');
        if (qrElem != null) {
            let svgString = qr.createSvgTag(5);
            // Replace xMinYMin with xMidYMid for proper centering
            svgString = svgString.replace('preserveAspectRatio="xMinYMin meet"', 'preserveAspectRatio="xMidYMid meet"');
            qrElem.innerHTML = svgString;
        }
    };

    /**
     * Downloads backup codes as a text file.
     *
     * @function download_codes
     */
    download_codes = () => {
        let TextToCode = this.settings.totp_data.backup_codes;
        let TextToCodeString = '';
        TextToCode.forEach(function (item) {
            TextToCodeString += item + '\n';
        });
        let downloadLink = document.createElement('a');
        downloadLink.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(TextToCodeString));
        downloadLink.setAttribute('download', 'backup_codes.txt');
        downloadLink.style.display = 'none';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
    };

    /**
     * This function copies the text from the `totp_data.key` property of the `settings` object
     * using the Clipboard API. It then shows a success message and reverts back to the original display
     * after a specified timeout.
     *
     * @function copyTextAndShowMessage
     * @memberof BaseAuth
     */
    copyTextAndShowMessage = () => {
        let text = this.settings.totp_data.key; // Get the text to be copied
        if(this.getElement('totp-key') === null) {
            return;
        }

        // Use Clipboard API to copy the text
        navigator.clipboard.writeText(text).then(() => {
            // Change the display of the key
            let originalText = this.getElement('totp-key').innerText;
            this.getElement('totp-key').innerText = this.settings.translatables.keyCopied;
            this.getElement('totp-key').style.color = 'green';

            // Revert back to original text after a timeout
            setTimeout(() => {
                this.getElement('totp-key').innerText = originalText;
                this.getElement('totp-key').style.color = ''; // Reset the color
            }, 2000); // Adjust timeout as needed

        }, function (err) {
            console.error(this.settings.translatables.keyCopiedFailed, err);
        });
    }

}

export default BaseAuth;